import { useRef } from "react";
import { Volume2 } from "lucide-react";
import type { AudioFile } from "../../shared/types";

export function AudioPlayer({ audio, rate = 1, compact = false }: { audio: AudioFile | null; rate?: number; compact?: boolean }) {
  const ref = useRef<HTMLAudioElement>(null);
  if (!audio?.url) return <span className="muted">Chưa có voice</span>;
  const play = () => {
    if (!ref.current) return;
    ref.current.playbackRate = rate;
    ref.current.currentTime = 0;
    void ref.current.play().catch(() => undefined);
  };
  return (
    <span className={`audio-player ${compact ? "compact" : ""}`}>
      <audio ref={ref} preload="metadata" src={audio.url} />
      <button className="icon-button" title="Phát âm" aria-label="Phát âm" onClick={play}><Volume2 size={19} /></button>
    </span>
  );
}
